export const variants = {
  lg: 'body-text-lg',
  md: 'body-text-md',
  sm: 'body-text-sm',
  xs: 'body-text-xs',
  none: '',
} as const;
